import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('LIGHTNING_BOLT', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  if (progress > 0.3) return;
  const count = 5;
  for (let i = 0; i < count; i++) {
    const angle = (i / count) * Math.PI * 2;
    ctx.strokeStyle = determineColor(i, count);
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(e.pos.x, e.pos.y);
    let cx = e.pos.x, cy = e.pos.y;
    for (let j = 0; j < 5; j++) {
      cx += Math.cos(angle + (Math.random() - 0.5)) * 30;
      cy += Math.sin(angle + (Math.random() - 0.5)) * 30;
      ctx.lineTo(cx, cy);
    }
    ctx.stroke();
  }
});
